import Device from "~/ts/library/Device";

const phoneRegex = /(?:^|\s)(\+?\d[\d\s\-()]{7,15}\d)(?!\w)/g;
const splitter = /(<[^>]+>|https?:\/\/[^\s]+)/g;

const isMobile = Device.mobile();
export default function linkifyMobilePhoneInText(text: string): string {
    if (isMobile) {
        const parts = text.split(splitter);

        const processedParts = parts.map(part => {
            if (part.startsWith('<') || part.startsWith('http')) {
                return part;
            }
            return part.replace(phoneRegex, match => {

                let cleanNumber = match.replace(/[\s\-()]/g, '');
                if (cleanNumber.startsWith("8000")) {
                    return match;
                }
                let prepend = "";
                if (match[0]!.match(/\s/)) {
                    prepend = match[0]!;
                    match = match.substring(1);
                }
                if (!cleanNumber.startsWith("8")) {
                    if (!cleanNumber.includes("+") && cleanNumber.length == 11) {
                        cleanNumber = `+${cleanNumber}`;
                    }
                }
                return `${prepend}<a href="tel:${cleanNumber}">${match}</a>`;
            });
        });

        // Собираем обратно в строку
        return processedParts.join('');
    } else {
        return text;
    }
}